import React from "react";

import styled from "styled-components";

import { ButtonOutlinePrimary, ReactRouterLink } from "../../atoms/Button";
import { Heading } from "../../atoms/Heading";
import { PageHeaderWrapper } from "../../components/PageHeaderWrapper/PageHeaderWrapper";
import { LayoutContainer } from "../../components/layout/LayoutContainer";
import { APPLICATION_SPACING } from "../../styling/spacing";

const StyledLayoutContainer = styled(LayoutContainer)`
  height: calc(100vh - 155px);
`;

const StyledButtonOutlinePrimary = styled(ButtonOutlinePrimary)`
  margin-top: ${APPLICATION_SPACING(4)};
  align-items: center;
  display: flex;
`;

export const PermissionDenied = () => {
  return (
    <PageHeaderWrapper breadcrumb={["Metomic"]}>
      <StyledLayoutContainer
        display="flex"
        alignSelf="stretch"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        flex="1"
        as="div"
      >
        <Heading Element="h1" type="display-large" isBodyColor>
          Permission Denied
        </Heading>
        <LayoutContainer maxWidth={540}>
          <p>
            You do not have the correct permissions to access this page, if you
            think this is a mistake, please contact your Metomic account owner.
          </p>
        </LayoutContainer>
        <StyledButtonOutlinePrimary as={ReactRouterLink} to="/">
          Return Home
        </StyledButtonOutlinePrimary>
      </StyledLayoutContainer>
    </PageHeaderWrapper>
  );
};
